// extracted by mini-css-extract-plugin
export default {"aboutInfoContainer":"LoveTechTalks_aboutInfoContainer__5PXyx","aboutInfoBlock":"LoveTechTalks_aboutInfoBlock__5z3TV"};